module.exports = __webpack_public_path__ + "img/109-Blanc Structuré.jpg";